import React, { Fragment } from 'react';
import { Card, CardBody, Badge, CustomInput, Button } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import ReplyFormButton from './ReplyFormButton';

const ReplyListItem = ({ item, LoadData, type, index, onEdit }) => {
  const isEvenRow = index % 2 === 0;
  const isTemplate = type === "whatsapp" || type === "sms";

  return (
    <Colxx xxs="14">
      <div
        className="d-flex align-items-center px-3 py-3"
        style={{
          backgroundColor: isEvenRow ? "#F7F7F7" : "#FFFFFF",
          fontSize: 14,
        }}
      >
        {/* Name */}
        <div style={{ flex: 2.5, fontWeight: 500, paddingRight: 20 }}>
          {isTemplate ? item.name : item.name}
        </div>

        {/* Message / Body */}
        <div style={{ flex: 3.5, fontSize: 13, color: "#555", paddingRight: 20 }}>
          {isTemplate ? item.templateBody : item.message}
        </div>

        {/* ID */}
        <div style={{ flex: 2, fontSize: 12 }}>
          {isTemplate ? item.templateId : item.id}
        </div>

        {/* Type */}
        {/* <div style={{ width: 90, fontSize: 13, paddingLeft: 20 }}>
          {isTemplate ? item.templateType : item.templateType}
        </div> */}
        {type !== "chat" && (
          <div style={{ width: 120, fontSize: 13, paddingLeft: 20 }}>
            {isTemplate
              ? (item.channel?.includes("sms")
                ? item.messageType
                : item.templateContentType)
              : item.templateType}
          </div>
        )}
        {/* Action */}
        <div style={{ width: 90, textAlign: "right" }}>
          {isTemplate ? (
            <Button
              size="xs"
              color="primary"
              style={{ borderRadius: 20 }}
              onClick={() => onEdit && onEdit(item)}
            >
              Edit
            </Button>
          ) : (
            <ReplyFormButton id={item.id} LoadData={LoadData} />
          )}
        </div>
      </div>
    </Colxx>
  );
};

export default React.memo(ReplyListItem);
